module.exports = {"id":"199974","name":"Ahmet İlhan Özek","rating":"71","photo":"./data/images/photos/2/199974.png","club":{"name":"Gençlerbirliği","logo":"./data/images/clubs/Genclerbirligi.png"},"positions":["MD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AhmetIlhanOzek0.json
// module id = 134
// module chunks = 0